import { render, staticRenderFns } from "./TasweqListView.vue?vue&type=template&id=6a8c4ff2&scoped=true"
import script from "./TasweqListView.vue?vue&type=script&lang=js"
export * from "./TasweqListView.vue?vue&type=script&lang=js"
import style0 from "./TasweqListView.vue?vue&type=style&index=0&id=6a8c4ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8c4ff2",
  null
  
)

export default component.exports